export const SET_CATEGORIE_DOCUMENTAZIONE = 'SET_CATEGORIE_DOCUMENTAZIONE';
